import { doc, updateDoc } from "@firebase/firestore";
import { projectFirestoreDB } from "../../firebase/config";

const algosdk = require("algosdk");

const baseServer = "https://testnet-algorand.api.purestake.io/ps2";
const port = "";
const token = {
  "X-API-Key": "Xjkl8ZiHlp3KmTEFhXAF8orYqdHo8W03zvsBgqM8",
};

const algodclient = new algosdk.Algodv2(token, baseServer, port);

/* const printCreatedAsset = async function (algodclient, account, assetid) {
  // note: if you have an indexer instance available it is easier to just use this
  //     let accountInfo = await indexerClient.searchAccounts()
  //    .assetID(assetIndex).do();
  // and in the loop below use this to extract the asset for a particular account
  // accountInfo['accounts'][idx][account]);
  let accountInfo = await algodclient.accountInformation(account).do();
  for (idx = 0; idx < accountInfo["created-assets"].length; idx++) {
    let scrutinizedAsset = accountInfo["created-assets"][idx];
    if (scrutinizedAsset["index"] == assetid) {
      console.log("AssetID = " + scrutinizedAsset["index"]);
      let myparms = JSON.stringify(scrutinizedAsset["params"], undefined, 2);
      console.log("parms = " + myparms);
      break;
    }
  }
};

const printAssetHolding = async function (algodclient, account, assetid) {
  // note: if you have an indexer instance available it is easier to just use this
  //     let accountInfo = await indexerClient.searchAccounts()
  //    .assetID(assetIndex).do();
  // and in the loop below use this to extract the asset for a particular account
  // accountInfo['accounts'][idx][account]);
  let accountInfo = await algodclient.accountInformation(account).do();
  for (idx = 0; idx < accountInfo["assets"].length; idx++) {
    let scrutinizedAsset = accountInfo["assets"][idx];
    if (scrutinizedAsset["asset-id"] == assetid) {
      let myassetholding = JSON.stringify(scrutinizedAsset, undefined, 2);
      console.log("assetholdinginfo = " + myassetholding);
      break;
    }
  }
}; */

export default async function createNFT(memeid, title) {
  //(async (memeid, title, asseturl) => {
  console.log("NFT creation transaction started...");
  let params = await algodclient.getTransactionParams().do();
  // comment out the next two lines to use suggested fee
  // params.fee = 1000;
  // params.flatFee = true;
  let note = undefined; // arbitrary data to be stored in the transaction; here, none is stored
  // Asset creation specific parameters
  // The following parameters are asset specific
  // Throughout the example these will be re-used.
  // We will also change the manager later in the example
  var account1 = algosdk.mnemonicToSecretKey(
    "history edge finger firm gate biology robust trash left choose slim rice example addict any arena universe offer beach final beauty inner gun abstract marble"
  );
  let addr = account1.addr;
  // Whether user accounts will need to be unfrozen before transacting
  let defaultFrozen = false;
  // integer number of decimals for asset unit calculation
  let decimals = 0;
  // total number of this asset available for circulation
  let totalIssuance = 1;
  // Used to display asset units to user
  let unitName = "memaNFT";
  // Friendly name of the asset
  let assetName = title;
  // Optional string pointing to a URL relating to the asset
  let assetURL =
    "https://us-central1-mema-3473f.cloudfunctions.net/app/api/" +
    memeid +
    "#arc3";
  // Optional hash commitment of some sort relating to the asset. 32 character length.
  let assetMetadataHash = "16efaa3924a6fd9d3a4824799a4ac65c";
  // The following parameters are the only ones
  // that can be changed, and they have to be changed
  // by the current manager
  // Specified address can change reserve, freeze, clawback, and manager
  let manager = account1.addr;
  // Specified address is considered the asset reserve
  // (it has no special privileges, this is only informational)
  //let reserve = recoveredAccount2.addr;
  let reserve = account1.addr;
  // Specified address can freeze or unfreeze user asset holdings
  //let freeze = recoveredAccount2.addr;
  let freeze = account1.addr;
  // Specified address can revoke user asset holdings and send
  // them to other addresses
  //let clawback = recoveredAccount2.addr;
  let clawback = account1.addr;

  // signing and sending "txn" allows "addr" to create an asset
  let txn = algosdk.makeAssetCreateTxnWithSuggestedParams(
    addr,
    note,
    totalIssuance,
    decimals,
    defaultFrozen,
    manager,
    reserve,
    freeze,
    clawback,
    unitName,
    assetName,
    assetURL,
    assetMetadataHash,
    params
  );

  let rawSignedTxn = txn.signTxn(account1.sk);
  let tx = await algodclient.sendRawTransaction(rawSignedTxn).do();

  let assetID = null;
  // wait for transaction to be confirmed
  const ptx = await algosdk.waitForConfirmation(algodclient, tx.txId, 4);
  // Get the new asset's information from the creator account
  assetID = ptx["asset-index"];
  //Get the completed Transaction
  console.log(
    "Transaction " + tx.txId + " confirmed in round " + ptx["confirmed-round"]
  );
  console.log("https://testnet.algoexplorer.io/tx/" + tx.txId);

  // updates the isMinted property to true
  const memeRef = doc(projectFirestoreDB, "memeImages", memeid);
  updateDoc(memeRef, {
    isMinted: true,
  });

  //await printCreatedAsset(algodclient, account1.addr, assetID);
  //await printAssetHolding(algodclient, account1.addr, assetID);
  // your terminal output should ber similar to this

  // Transaction: BQMRGV6VZLXXPI4OEEJB6OGFRVJQEKWFJULNPMGVF25H7WE6EUQA
  // Transaction BQMRGV6VZLXXPI4OEEJB6OGFRVJQEKWFJULNPMGVF25H7WE6EUQA confirmed in round 3961853
  // AssetID = 2653785
  // parms = {
  //     "clawback": "AK6Q33PDO4RJZQPHEMODC6PUE5AR2UD4FBU6TNEJOU4UR4KC6XL5PWW5K4",
  //     "creator": "ATTR6RUEHHBHXKUHT4GUOYWNBVDV2GJ5FHUWCSFZLHD55EVKZWOWSM7ABQ",
  //     "decimals": 0,
  //     "default-frozen": false,
  //     "freeze": "AK6Q33PDO4RJZQPHEMODC6PUE5AR2UD4FBU6TNEJOU4UR4KC6XL5PWW5K4",
  //     "manager": "AK6Q33PDO4RJZQPHEMODC6PUE5AR2UD4FBU6TNEJOU4UR4KC6XL5PWW5K4",
  //     "metadata-hash": "MTZlZmFhMzkyNGE2ZmQ5ZDNhNDgyNDc5OWE0YWM2NWQ=",
  //     "name": "latinum",
  //     "reserve": "AK6Q33PDO4RJZQPHEMODC6PUE5AR2UD4FBU6TNEJOU4UR4KC6XL5PWW5K4",
  //     "total": 1000,
  //     "unit-name": "LATINUM",
  //     "url": "http://someurl"
  // }
  // AssetExample.js: 69
  // assetholdinginfo = {
  //     "amount": 1000,
  //     "asset-id": 2653785,
  //     "creator": "ATTR6RUEHHBHXKUHT4GUOYWNBVDV2GJ5FHUWCSFZLHD55EVKZWOWSM7ABQ",
  //     "is-frozen": false
  // }
}
/* ().catch((e) => {
  console.log(e);
  console.trace();
}); */

//export default createNFT;
